'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var $ = require("jquery");
var Form = /** @class */ (function () {
    function Form() {
        var _this = this;
        this.error_flag = false;
        this.errorFlagArray = '';
        this.SPEED = 500;
        $('.trigCheckForm').on('click', function (e) {
            _this.errorFlagArray = [];
            // console.log('this.errorFlagArray = [];', this.errorFlagArray);
            if (_this.isError()) {
                // フォーム処理中断
                e.preventDefault();
                $('.bulletShowError').attr('data-show', '1');
                // エラーメッセージまでの移動
                _this.scrollErrorMessage();
            }
            else {
                $('.bulletShowError').attr('data-show', '0');
            }
        });
    }
    // フォームエラーの判定
    Form.prototype.isError = function () {
        this.checkError();
        var isError = this.errorFlagArray.some(function (item) { return item === true; });
        return isError;
    };
    // フォームのエラーを配列に入れる
    Form.prototype.checkError = function () {
        if ($('.paramEstimate').length) {
            // お見積りフォームのチェック
            this.errorFlagArray.push(this.checkSelectBox());
            this.errorFlagArray.push(this.checkArea());
            this.errorFlagArray.push(this.checkMapTarget());
            this.errorFlagArray.push(this.checkScale());
            this.errorFlagArray.push(this.checkCompany());
            this.errorFlagArray.push(this.checkName());
            this.errorFlagArray.push(this.checkNameKana());
            this.errorFlagArray.push(this.checkMail());
            this.errorFlagArray.push(this.checkTel());
            this.errorFlagArray.push(this.checkTextarea());
            this.errorFlagArray.push(this.checkAccept());
        }
        else {
            // お問い合わせフォームのチェック
            this.errorFlagArray.push(this.checkSelectBox());
            this.errorFlagArray.push(this.checkName());
            this.errorFlagArray.push(this.checkNameKana());
            this.errorFlagArray.push(this.checkMail());
            this.errorFlagArray.push(this.checkTel());
            this.errorFlagArray.push(this.checkTextarea());
            this.errorFlagArray.push(this.checkAccept());
        }
    };
    Form.prototype.checkSelectBox = function () {
        var val = $('option:selected').val();
        if (val !== undefined) {
            var mustId = $('select[name="category"]').attr('data-must-id');
            if (Number(val) !== 0) {
                this.error_flag = false;
                $('[data-error-id="' + mustId + '"]').text('');
            }
            else {
                console.log('お問い合わせ項目：ご用件をお選びください。');
                this.error_flag = true;
                $('[data-error-id="' + mustId + '"]').text('お問い合わせ項目：ご用件をお選びください。');
            }
        }
        else {
            this.error_flag = false;
        }
        return this.error_flag;
    };
    Form.prototype.checkArea = function () {
        var target = $('input[name="area"]');
        var val = target.val();
        var mustId = $(target).attr('data-must-id');
        if (Number(val) > 0 && !/^0/.test(val)) {
            this.error_flag = false;
            $('[data-error-id="' + mustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + mustId + '"]').text('図化面積：半角数字で入力してください。');
        }
        return this.error_flag;
    };
    Form.prototype.checkMapTarget = function () {
        var val = $('input[name="map_target"]:checked').attr('data-price');
        var mustId = $('input[name="map_target"]').attr('data-must-id');
        if (val !== undefined) {
            this.error_flag = false;
            $('[data-error-id="' + mustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + mustId + '"]').text('図化対象：選択してください。');
        }
        return this.error_flag;
    };
    Form.prototype.checkScale = function () {
        var val = $('input[name="scale"]:checked').attr('data-price');
        var mustId = $('input[name="scale"]').attr('data-must-id');
        if (val !== undefined) {
            this.error_flag = false;
            $('[data-error-id="' + mustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + mustId + '"]').text('縮尺：選択してください。');
        }
        return this.error_flag;
    };
    Form.prototype.checkTextarea = function () {
        var target = $('textarea[name="body"]');
        var val = target.val();
        var mustId = target.attr('data-must-id');
        if (val !== '') {
            this.error_flag = false;
            $('[data-error-id="' + mustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + mustId + '"]').text('お問い合わせ内容：入力してください。');
        }
        return this.error_flag;
    };
    Form.prototype.checkCompany = function () {
        var target = $('input[name="company_name"]');
        var val = target.val();
        var mustId = target.attr('data-must-id');
        if (val !== '') {
            this.error_flag = false;
            $('[data-error-id="' + mustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + mustId + '"]').text('会社名：入力してください。');
        }
        return this.error_flag;
    };
    Form.prototype.checkName = function () {
        var seiVal = $('input[name="sei"]').val();
        var seiMustId = $('input[name="sei"]').attr('data-must-id');
        var meiVal = $('input[name="mei"]').val();
        var meiMustId = $('input[name="mei"]').attr('data-must-id');
        if (seiVal !== '' && meiVal !== '') {
            this.error_flag = false;
            $('[data-error-id="' + seiMustId + '"]').text('');
            $('[data-error-id="' + meiMustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + seiMustId + '"]').text('お名前：姓を入力してください。');
            $('[data-error-id="' + meiMustId + '"]').text('お名前：名を入力してください。');
        }
        return this.error_flag;
    };
    Form.prototype.checkNameKana = function () {
        var seiKanaVal = $('input[name="sei_kana"]').val();
        var seiKanaMustId = $('input[name="sei_kana"]').attr('data-must-id');
        var meiKanaVal = $('input[name="mei_kana"]').val();
        var meiKanaMustId = $('input[name="mei_kana"]').attr('data-must-id');
        if (seiKanaVal !== '' && meiKanaVal !== '') {
            this.error_flag = false;
            $('[data-error-id="' + seiKanaMustId + '"]').text('');
            $('[data-error-id="' + meiKanaMustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + seiKanaMustId + '"]').text('フリガナ：セイを入力してください。');
            $('[data-error-id="' + meiKanaMustId + '"]').text('フリガナ：メイを入力してください。');
        }
        return this.error_flag;
    };
    // メールアドレス
    Form.prototype.checkMail = function () {
        var emailVal = $('input[name="email"]').val();
        var emailMustId = $('input[name="email"]').attr('data-must-id');
        var emailReVal = $('input[name="email_re"]').val();
        var emailReMustId = $('input[name="email_re"]').attr('data-must-id');
        if (emailVal !== '' || this.isAddress(emailVal)) {
            this.error_flag = false;
            $('[data-error-id="' + emailMustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + emailMustId + '"]').text('メールアドレス：入力してください。');
        }
        // 再入力
        if (emailReVal === '' || !this.isAddress(emailReVal)) {
            this.error_flag = true;
            $('[data-error-id="' + emailReMustId + '"]').text('確認用メールアドレス：入力してください。');
        }
        else if (emailReVal === '' || emailVal !== emailReVal) {
            this.error_flag = true;
            $('[data-error-id="' + emailReMustId + '"]').text('確認用メールアドレス：メールアドレスが一致しません');
        }
        else {
            this.error_flag = false;
            $('[data-error-id="' + emailReMustId + '"]').text('');
        }
        return this.error_flag;
    };
    // 電話番号
    Form.prototype.checkTel = function () {
        var telVal = $('input[name="tel"]').val().replace(/-/g, '');
        var mustId = $('input[name="tel"]').attr('data-must-id');
        if (telVal !== '' || this.isPhoneNumber(telVal)) {
            this.error_flag = false;
            $('[data-error-id="' + mustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + mustId + '"]').text('電話番号：入力してください。');
        }
        return this.error_flag;
    };
    Form.prototype.checkAccept = function () {
        var target = $('input[name="accept"]');
        var checked = target.prop('checked');
        var mustId = target.attr('data-must-id');
        if (checked === true) {
            this.error_flag = false;
            $('[data-error-id="' + mustId + '"]').text('');
        }
        else {
            this.error_flag = true;
            $('[data-error-id="' + mustId + '"]').text('個人情報保護に同意する：同意頂く必要があります。');
        }
        return this.error_flag;
    };
    Form.prototype.isAddress = function (address) {
        var reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
        if (reg.test(address)) {
            return true;
        }
        else {
            return false;
        }
    };
    Form.prototype.isPhoneNumber = function (phoneNumber) {
        var reg = /^[0][0-9]{9,10}$/;
        if (reg.test(phoneNumber)) {
            return true;
        }
        else {
            return false;
        }
    };
    // エラーメッセージ箇所までの移動
    Form.prototype.scrollErrorMessage = function () {
        var position = $('.paramError').offset().top;
        var headerHeight = 0;
        // 現在表示されているheaderの高さを取得
        if ($('.paramPcHeader').is(':visible')) {
            headerHeight = $('.paramPcHeader').outerHeight();
        }
        else {
            headerHeight = $('.paramSpHeader').outerHeight();
        }
        // 移動実行
        $('html, body').animate({ scrollTop: position - headerHeight }, this.SPEED);
    };
    return Form;
}());
exports.Form = Form;
exports.default = Form;
